import { appAuthAtom, AuthState, LogoutReason } from '@eih-netbroker/common';
import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { useLogger } from '../../utils/useLogger';

/**
 * Hook for logging out
 */
export const useLogout = () => {
  const logger = useLogger(`useLogout`);
  const [appAuth, setAppAuth] = useAtom(appAuthAtom);

  /**
   * Public logout method, starts the logout sequence by setting the authState and the actual logout
   * is happening through the AuthContext
   * @param reason reason of the logout
   */
  const logout = useCallback(
    async (reason?: LogoutReason) => {
      logger.info(`Start logout because ${reason}, user is authenticated? ${appAuth.isAuthenticated}`);
      if (appAuth.isAuthenticated) {
        setAppAuth({ ...appAuth, isAuthenticated: true, authStatus: AuthState.SignOff, error: reason });
      } else {
        setAppAuth({ isAuthenticated: false, authStatus: AuthState.SignOff, error: reason });
      }
    },
    [appAuth, setAppAuth, logger],
  );

  return useMemo(
    () => ({
      logout,
    }),
    [logout],
  );
};
